import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Col,
  Divider,
  PageHeader,
  Row,
  Spin,
  Form as FormInitial,
  message,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  InputNumberItem,
  InputItem,
  ButtonItem,
  ErrorItem,
  SelectInsumosItem
} from "../../../../Components/Items";

class AgregarListaDeMateriales extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    todasInsumos: null,
    objetoInsumos: null,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    this.setState({ loading: false });
  }

  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "listasdemateriales/agregarListaDeMateriales",
        {
          ...values,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se agrego una lista de materiales");
          this.atras();
        } else if (res.data.success === 1) {
          message.error("No se pudo guardar la lista de materiales");
        } else {
          message.error("Hubo un error y la lista no se guardo");
        }
      });
  }
  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Lista de Materiales"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarListaDeMateriales"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Agregar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem
                    label="Nombre"
                    name="nombre"
                    required
                    margin
                    pattern
                  >
                    <InputItem placeholder="Nombre" />
                  </FormItem>
                </Col>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem
                    label="Descripción"
                    name="descripcion"
                    margin
                    pattern
                  >
                    <InputItem placeholder="Descripción" />
                  </FormItem>
                </Col>
              </Row>
              <Divider
                style={{ marginBottom: 10, marginTop: 5 }}
                children="Insumo a Generar"
              />
              <Row>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem
                    label="Insumo a Generar"
                    name="insumoAGenerarId"
                    margin
                    required
                  >
                    <SelectInsumosItem
                      empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                      headersToken={this.props.headersToken}
                      sinBorde
                      autoFocus
                      dropdownMatchSelectWidth={600}
                      width="100%"
                      placeholder="Insumo a Generar"
                      tiposInsumos="inventariables"
                    />
                  </FormItem>
                </Col>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem
                    label="Cantidad a Generar"
                    name="cantidadAGenerar"
                    number
                    required
                    type="number"
                    initialValue={1}
                    tooltip="Esta deberia ser la cntidad minima que se puede producir."
                  >
                    <InputNumberItem />
                  </FormItem>
                </Col>
              </Row>
              <Divider
                style={{ marginBottom: 10, marginTop: 5 }}
                children="Insumos a Utilizar"
              />
              <FormInitial.List name="insumosAUtilizar">
                {(fields, { add, remove }) => (
                  <>
                    <div style={{ overflowX: 'auto' }}>
                      <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                        {fields.length > 0 ? (
                          <thead>
                            <tr>
                              <th className="th-border" style={{ width: "70%" }}>
                                Insumo
                              </th>
                              <th className="th-border" style={{ width: "30%" }}>
                                Cantidad
                              </th>
                            </tr>
                          </thead>
                        ) : null}
                        {fields.map(
                          ({ key, name, fieldKey, ...restField }, arrayKey) => (
                            <tbody>
                              <tr>
                                <td className="td-border">
                                  <FormItem
                                    {...restField}
                                    name={[name, "insumoId"]}
                                    fieldKey={[arrayKey, "insumoId"]}
                                    required
                                    noStyle
                                  >
                                    <SelectInsumosItem
                                      empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                      headersToken={this.props.headersToken}
                                      sinBorde
                                      autoFocus
                                      dropdownMatchSelectWidth={600}
                                      width="100%"
                                      placeholder="Insumo"
                                      tiposInsumos="inventariables"
                                    />
                                  </FormItem>
                                </td>
                                <td className="td-border">
                                  <FormItem
                                    {...restField}
                                    name={[name, "cantidad"]}
                                    fieldKey={[arrayKey, "cantidad"]}
                                    number
                                    noStyle
                                    required
                                    type="number"
                                    initialValue={undefined}
                                  >
                                    <InputNumberItem sinBorde />
                                  </FormItem>
                                </td>
                                <td>
                                  <MinusCircleOutlined
                                    onClick={() => remove(name)}
                                    style={{
                                      alignSelf: "center",
                                      justifySelf: "center",
                                    }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          )
                        )}
                      </table>
                    </div>
                    <FormItem noStyle>
                      <ButtonItem
                        style={{ marginTop: 10, marginBottom: 10 }}
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Agregar Campo
                      </ButtonItem>
                    </FormItem>
                  </>
                )}
              </FormInitial.List>
            </Form>
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarListaDeMateriales);
